<template>
	<div class="jumbotron">
		<div class="container'">
			<div class="row justify-content-between">
				<div class="col">
					<h1 class="display-3">Hawkeye Server Monitoring</h1>
					<p class="lead">Teedrei Inc</p>
					<p>Developed By: <a href="https://edwardbiton.teedrei.com">Edward Biton</a></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'about',
  data: () => ({
  })
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// HomePage.vue?907e1978